export default __webpack_public_path__ + "static/Entertain-the-kids-with-games-e036c573fdc460e2929b0d1448a5cc99.jpg";